import { ExperiencerDocsService } from 'core/api/services/experiencerDocs';
import React, { useContext, useState } from 'react';

const ExperiencerDocsContext = React.createContext(null);

export const ExperiencerDocsProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [experiencerDocs, setExperiencerDocs] = useState([]);
  const [currentDocs, setCurrentDocs] = useState([]);
  const [isCurrentVersion, setIsCurrentVersion] = useState(null);

  const getExperiencerDocs = async (experiencerId) => {
    try {
      setLoading(true);
      const result = await ExperiencerDocsService.getExperiencerDocs(experiencerId);

      if (result) {
        setExperiencerDocs(result?.experiencerDocs || []);
        setCurrentDocs(result?.currencyDocs || []);  
        setIsCurrentVersion(
          (result.currencyDocs || []).map((doc) => doc.id)
        );
      } else {
        setExperiencerDocs([]);
        setCurrentDocs([]);
        setIsCurrentVersion(null);
      }

      return result;
    } catch (error) {
      console.error(error);
      setExperiencerDocs([]);
      setCurrentDocs([]);
      setIsCurrentVersion(null);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const updateExperiencerDoc = async (experiencerId, docId, updatedFields) => {
    try {
      setLoading(true);
      const success = await ExperiencerDocsService.updateExperiencerDoc(
        experiencerId,
        docId,
        updatedFields
      );
      if (success) {
        await getExperiencerDocs(experiencerId);
      }
      return success;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return (
    <ExperiencerDocsContext.Provider
      value={{
        loading,
        experiencerDocs,
        currentDocs,      
        isCurrentVersion,
        getExperiencerDocs,
        updateExperiencerDoc,
      }}
    >
      {children}
    </ExperiencerDocsContext.Provider>
  );
};

ExperiencerDocsProvider.displayName = 'ExperiencerDocs';

export const useExperiencerDocs = () => useContext(ExperiencerDocsContext);
